import {createGlobalContext} from "@acng/frontend-relativity";
import {authUser as authUserData} from "acng/core/service/env.js";

export let authUser = authUserData;

export const ctxAuthUser = createGlobalContext(authUser);
